import React, { useEffect, useState, useCallback } from "react"
import Moment from "react-moment";
import { getFieldData, getFormatedNumber } from "../../Services/appService";
import { useNavigate } from "react-router-dom";
import PurchaseOrders from "../../Components/ApplicantProcessing/PurchaseOrders";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser, getLoggedUserDetails, loadUserDetails } from "../store/auth";
import { getPartnerAllCandidate } from "../store/partner";
import { useLoadPartnerAllCandidateQuery } from "../store/partnerApiSlice";
import { setCurrentPageTitle, setCurrentRoute } from "../store/layoutUI";
import { getComponentUserStatus, getToolsCount, UpdateComponentsUserStatus } from "../store/tools";

const PARTNER_CANDIDATE_STYLES = {
    shell: {
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        borderRadius: "0px",
        border: "1px solid #e5e5e5",
        backgroundColor: "#ffffff",
        boxShadow: "none",
        overflow: "hidden"
    },
    hero: {
        padding: "14px 20px",
        borderBottom: "1px solid #e5e5e5",
        background: "transparent"
    },
    heroRow: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        flexWrap: "wrap"
    },
    heroCopy: {
        flex: "1 1 420px",
        minWidth: "280px"
    },
    titleRow: {
        display: "flex",
        alignItems: "center",
        gap: "12px"
    },
    titleIcon: {
        width: "32px",
        height: "32px",
        borderRadius: "0px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        color: "#000000",
        fontSize: "14px",
        border: "1px solid #e5e5e5",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
        flexShrink: 0
    },
    titleText: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        minWidth: 0
    },
    eyebrow: {
        display: "inline-block",
        marginBottom: "8px",
        color: "#2563eb",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.12em",
        textTransform: "uppercase"
    },
    title: {
        margin: 0,
        color: "#000000",
        fontSize: "16px",
        fontWeight: 600,
        lineHeight: 1.25
    },
    subtitle: {
        fontSize: "13px",
        lineHeight: 1.5,
        color: "#666666",
        margin: 0,
        fontWeight: "normal"
    },
    heroBadgeRow: {
        display: "flex",
        gap: "10px",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "flex-end"
    },
    refreshButton: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        borderRadius: "0px",
        border: "1px solid #e5e5e5",
        background: "#ffffff",
        color: "#333333",
        padding: "8px 16px",
        fontSize: "13px",
        fontWeight: 600,
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
        cursor: "pointer",
        transition: "all 0.2s ease"
    },
    heroBadge: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        padding: "10px 14px",
        borderRadius: "0px",
        border: "1px solid rgba(191, 219, 254, 1)",
        backgroundColor: "#ffffff",
        color: "#1d4ed8",
        fontSize: "12px",
        fontWeight: 600,
        boxShadow: "none"
    },
    statsGrid: {
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
        gap: "14px",
        padding: "20px 22px"
    },
    statCard: {
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
        backgroundColor: "#ffffff",
        border: "1px solid rgba(226, 232, 240, 0.95)",
        borderRadius: "0px",
        padding: "16px",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.04)",
        transition: "all 0.2s ease"
    },
    statIcon: {
        width: "36px",
        height: "36px",
        borderRadius: "0px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f1f5f9",
        color: "#0f172a",
        fontSize: "14px",
        flexShrink: 0
    },
    statContent: {
        minWidth: 0
    },
    statLabel: {
        margin: "0 0 4px 0",
        color: "#64748b",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase"
    },
    statValue: {
        margin: 0,
        color: "#0f172a",
        fontSize: "24px",
        fontWeight: 600,
        lineHeight: 1
    },
    tableWrap: {
        padding: "0"
    },
    tableShell: {
        overflowX: "auto",
        backgroundColor: "#ffffff"
    },
    table: {
        width: "100%",
        marginBottom: 0,
        borderCollapse: "separate",
        borderSpacing: 0,
        fontSize: "13px",
        color: "#334155"
    },
    tableHeadCell: {
        borderTop: "1px solid rgba(226, 232, 240, 0.9)",
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#64748b",
        background: "#f8fafc",
        borderBottom: "1px solid #e5e5e5",
        padding: "14px 16px"
    },
    tableCell: {
        padding: "14px 16px",
        borderBottom: "1px solid rgba(241, 245, 249, 1)",
        verticalAlign: "top",
        fontWeight: 600
    },
    candidateAvatar: {
        width: "38px",
        height: "38px",
        borderRadius: "0px",
        background: "#f8fafc",
        border: "1px solid #e2e8f0",
        color: "#0f172a",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "14px",
        fontWeight: 600,
        boxShadow: "none"
    },
    candidateName: {
        margin: 0,
        color: "#0f172a",
        fontSize: "14px",
        fontWeight: 600,
        textTransform: "uppercase"
    },
    infoText: {
        display: "flex",
        alignItems: "center",
        gap: "6px",
        color: "#475569",
        fontSize: "12.5px",
        lineHeight: 1.45,
        fontWeight: 500
    },
    idPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding: "0",
        borderRadius: "0px",
        backgroundColor: "transparent",
        border: "none",
        color: "#0f172a",
        fontSize: "12px",
        fontWeight: 600
    },
    secondaryPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        padding: "0",
        borderRadius: "0px",
        backgroundColor: "transparent",
        color: "#0f172a",
        fontSize: "12px",
        fontWeight: 600},
    statusBadge: {
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        padding: "6px 12px",
        borderRadius: "0px",
        fontSize: "12px",
        fontWeight: 600
    },
    actionButton: {
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        borderRadius: "0px",
        border: "1px solid #e5e5e5",
        background: "#ffffff",
        color: "#333333",
        padding: "8px 16px",
        fontSize: "13px",
        fontWeight: 600,
        boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
        cursor: "pointer",
        transition: "all 0.2s ease",
        whiteSpace: "nowrap",
        width: "fit-content"
    },
    emptyState: {
        padding: "42px 24px",
        textAlign: "center",
        backgroundColor: "#ffffff"
    },
    emptyIcon: {
        width: "64px",
        height: "64px",
        margin: "0 auto 14px auto",
        borderRadius: "0px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f8fafc",
        border: "1px solid #e2e8f0",
        color: "#0f172a",
        fontSize: "26px"
    },
    emptyTitle: {
        margin: 0,
        color: "#0f172a",
        fontSize: "18px",
        fontWeight: 600
    },
    emptyText: {
        margin: "10px auto 0 auto",
        color: "#64748b",
        fontSize: "14px",
        lineHeight: 1.6
    }
};

const PARTNER_CANDIDATE_ROUTE = [{ name: "Contract Management", url: "" }];

export default function PartnerCandidates() {

    const [candidateList, setCandidateList] = useState([]);
    const [candidateObj, setCandidateObj] = useState(null);
    const [poShowHide, setPoShowHide] = useState(false);
    const [userDetails, setUserDetails] = useState(false);

    const userDetailsSelector = useSelector(getLoggedUserDetails);
    const partnerAllCandidateSelector = useSelector(getPartnerAllCandidate);
    const componentUserStatusSelector = useSelector(getComponentUserStatus);
    const toolsCountSelector = useSelector(getToolsCount);

    const navigate = useNavigate();
    const currentUser = getCurrentUser();
    const currentUserId = currentUser?.id;
    const dispatch = useDispatch();

    const partnerId = (userDetailsSelector?.approved > 0) ? userDetailsSelector?.partnerid : null;

    // RTK Query Hook
    const { refetch: refetchPartnerCandidates } = useLoadPartnerAllCandidateQuery(
        { partId: partnerId, perfId: 0 },
        { skip: !partnerId }
    );

    useEffect(() => {
        dispatch(setCurrentPageTitle("List of Candidates"));
        dispatch(setCurrentRoute(PARTNER_CANDIDATE_ROUTE));
    }, [dispatch]);

    useEffect(() => {
        let targetUsrId = currentUser?.linkUser || currentUser?.id;
        if (!userDetailsSelector && targetUsrId) {
            dispatch(loadUserDetails(targetUsrId));
        }
    }, [dispatch, currentUser, userDetailsSelector]);

    useEffect(() => {
        if (userDetailsSelector && userDetailsSelector?.partnerid) {
            setUserDetails(userDetailsSelector);
        }
    }, [userDetailsSelector]);

    const handleUpdateComponent = useCallback((compItems, ciid) => {
        const comp = componentUserStatusSelector.filter(x => x.compId === 19);
        let updCompItems = "";
        if (comp.length > 0) {
            updCompItems = comp[0].compItems;
        }
        const compObj = {
            compName: "Partner Candidate",
            performerId: currentUserId,
            compItems: compItems,
            ciid: ciid,
            wiid: 0,
            iiid: 0,
            compId: 19
        }
        if (compItems !== "" && compItems !== updCompItems) {
            dispatch(UpdateComponentsUserStatus(compObj));
        }
    }, [componentUserStatusSelector, currentUserId, dispatch]);

    useEffect(() => {
        if (partnerAllCandidateSelector.length > 0) {
            setCandidateList(partnerAllCandidateSelector);
            let candItems = "";
            partnerAllCandidateSelector.forEach((x, key) => {
                if (key > 0) candItems += ",";
                candItems += x.performerid;
            });

            const appObj = toolsCountSelector?.filter(x => x.key === 0);
            let appCiid = 0;
            if (appObj.length > 0)
                appCiid = appObj[0].value;

            handleUpdateComponent(candItems, appCiid);
        } else {
            setCandidateList([]);
        }
    }, [partnerAllCandidateSelector, toolsCountSelector, handleUpdateComponent]);

    const usrType = localStorage.getItem("userType");

    const handleUploadDoc = useCallback((item) => {
        navigate("/CandidateWorkingHub", { state: item });
    }, [navigate]);

    const handlePoShowHide = useCallback((obj) => {
        setPoShowHide(prev => !prev);
        setCandidateObj(obj);
    }, []);

    const getPendingPoCount = (obj) => {
        let poType = "recruiter";
        if (userDetails?.partnerType === "Sub-Contractors") {
            poType = "subcontractor";
        }

        return obj?.poTypes?.filter(x => x.type === poType && x.partnerSign !== true && x.sendStatus === true).length || 0;
    }

    const getTotalPoCount = (obj) => {
        let poType = "recruiter";
        if (userDetails?.partnerType === "Sub-Contractors") {
            poType = "subcontractor";
        }

        return obj?.poTypes?.filter(x => x.type === poType && x.sendStatus === true).length || 0;
    }

    const getPoCount = (obj) => {
        const pendingCount = getPendingPoCount(obj);
        const totalCount = pendingCount === 0 ? getTotalPoCount(obj) : pendingCount;
        const badgeBg = pendingCount > 0 || totalCount === 0 ? "#ef4444" : "#22c55e";
        const badgeColor = "#ffffff";

        return <span style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            minWidth: "20px",
            height: "20px",
            borderRadius: "0px",
            backgroundColor: badgeBg,
            color: badgeColor,
            fontSize: "11px",
            fontWeight: 600,
            padding: "0 6px",
            }}>
            {totalCount}
        </span>
    }

    const handleRefreshPartnerCandidates = useCallback(() => {
        if (userDetailsSelector && userDetailsSelector?.partnerid) {
            setUserDetails(userDetailsSelector);
            refetchPartnerCandidates();
        }
    }, [userDetailsSelector, refetchPartnerCandidates]);

    const getInitials = (firstName, lastName) => {
        const f = firstName ? firstName.trim().charAt(0) : "";
        const l = lastName ? lastName.trim().charAt(0) : "";
        return (f + l).toUpperCase() || "??";
    };

    const completedCount = candidateList.filter(item => item.appSubmit).length;
    const pendingCount = candidateList.length - completedCount;
    const totalPendingPoCount = candidateList.reduce((sum, item) => sum + getPendingPoCount(item), 0);
    const totalPoCount = candidateList.reduce((sum, item) => sum + getTotalPoCount(item), 0);

    const getStatusBadgeStyle = (isComplete) => ({
        ...PARTNER_CANDIDATE_STYLES.statusBadge,
        backgroundColor: isComplete ? "#2dce898c" : "#ffd600",
        color: "#0f172a",
        border: `1px solid ${isComplete ? "#2dce89" : "#ffd600"}`
    });

    return <React.Fragment>
        <div className="mt-2">
            <style>{`
                .partner-candidates-table tbody tr:hover td {
                    background-color: #f8fbff !important;
                }

                @media (max-width: 991.98px) {
                    .partner-candidates-table {
                        min-width: 1040px;
                    }
                }
            `}</style>
            <div className="card shadow-none border-1" style={PARTNER_CANDIDATE_STYLES.shell}>
                <div style={PARTNER_CANDIDATE_STYLES.hero}>
                    <div style={PARTNER_CANDIDATE_STYLES.heroRow}>
                        <div style={PARTNER_CANDIDATE_STYLES.heroCopy}>
                            <div style={PARTNER_CANDIDATE_STYLES.titleRow}>
                                <span style={PARTNER_CANDIDATE_STYLES.titleIcon}>
                                    <i className="fa fa-list-ul" aria-hidden="true"></i>
                                </span>
                                <div style={PARTNER_CANDIDATE_STYLES.titleText}>
                                    <h2 style={PARTNER_CANDIDATE_STYLES.title}>List of Your Candidates</h2>
                                </div>
                            </div>
                        </div>
                        <div style={PARTNER_CANDIDATE_STYLES.heroBadgeRow}>
                            <button
                                type="button"
                                className="btn btn-sm"
                                style={PARTNER_CANDIDATE_STYLES.refreshButton}
                                onClick={handleRefreshPartnerCandidates}
                            >
                                <i className="fa fa-refresh" aria-hidden="true"></i>
                                Refresh
                            </button>

                        </div>
                    </div>
                </div>
                <div style={PARTNER_CANDIDATE_STYLES.statsGrid}>
                    <div style={PARTNER_CANDIDATE_STYLES.statCard}>
                        <div style={PARTNER_CANDIDATE_STYLES.statIcon}>
                            <i className="fa fa-users" aria-hidden="true"></i>
                        </div>
                        <div style={PARTNER_CANDIDATE_STYLES.statContent}>
                            <div style={PARTNER_CANDIDATE_STYLES.statLabel}>Total Candidates</div>
                            <div style={PARTNER_CANDIDATE_STYLES.statValue}>{candidateList.length}</div>
                        </div>
                    </div>
                    <div style={PARTNER_CANDIDATE_STYLES.statCard}>
                        <div style={{ ...PARTNER_CANDIDATE_STYLES.statIcon, background: "#ecfdf5", color: "#047857" }}>
                            <i className="fa fa-check-circle" aria-hidden="true"></i>
                        </div>
                        <div style={PARTNER_CANDIDATE_STYLES.statContent}>
                            <div style={PARTNER_CANDIDATE_STYLES.statLabel}>Onboarding Complete</div>
                            <div style={PARTNER_CANDIDATE_STYLES.statValue}>{completedCount}</div>
                        </div>
                    </div>
                    <div style={PARTNER_CANDIDATE_STYLES.statCard}>
                        <div style={{ ...PARTNER_CANDIDATE_STYLES.statIcon, background: "#fef2f2", color: "#b91c1c" }}>
                            <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                        </div>
                        <div style={PARTNER_CANDIDATE_STYLES.statContent}>
                            <div style={PARTNER_CANDIDATE_STYLES.statLabel}>Awaiting Attention</div>
                            <div style={PARTNER_CANDIDATE_STYLES.statValue}>{pendingCount}</div>
                        </div>
                    </div>
                    <div style={PARTNER_CANDIDATE_STYLES.statCard}>
                        <div style={{ ...PARTNER_CANDIDATE_STYLES.statIcon, background: "#fffbeb", color: "#b45309" }}>
                            <i className="fa fa-file-text-o" aria-hidden="true"></i>
                        </div>
                        <div style={PARTNER_CANDIDATE_STYLES.statContent}>
                            <div style={PARTNER_CANDIDATE_STYLES.statLabel}>Purchase Orders</div>
                            <div style={PARTNER_CANDIDATE_STYLES.statValue}>{totalPendingPoCount}</div>
                        </div>
                    </div>
                </div>
                <div style={PARTNER_CANDIDATE_STYLES.tableWrap}>

                    <div className="table-responsive" style={PARTNER_CANDIDATE_STYLES.tableShell}>
                        <table className="table align-items-center table-hover mb-0 partner-candidates-table" style={PARTNER_CANDIDATE_STYLES.table}>
                            <thead>
                                <tr>
                                    <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Candidate #<br />IPCS ID</th>
                                    <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Candidate Details</th>
                                    <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Agency</th>
                                    <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Duration<br />(Start-End)</th>
                                    <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Onboarding<br />Status</th>
                                    <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Purchase Orders</th>
                                    {usrType !== "recruiter" && <th style={PARTNER_CANDIDATE_STYLES.tableHeadCell}>Action</th>}

                                </tr>
                            </thead>
                            <tbody>
                                {candidateList.length > 0 && candidateList.map((item, index) => (
                                    <tr key={item.performerid} style={{ backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8fafc" }}>
                                        <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                            <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start" }}>
                                                <span style={PARTNER_CANDIDATE_STYLES.idPill}>
                                                    <span style={{ color: "#94a3b8", fontWeight: 600 }}>#</span> {item.performerid}
                                                </span>
                                                <span style={PARTNER_CANDIDATE_STYLES.secondaryPill}>
                                                    IPCS ID: {item.maxloans || "N/A"}
                                                </span>
                                            </div>
                                        </td>
                                        <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                            <div style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                                                <div style={PARTNER_CANDIDATE_STYLES.candidateAvatar}>
                                                    {getInitials(item.performername, item.lastName)}
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "column", gap: "3px", minWidth: 0 }}>
                                                    <p style={PARTNER_CANDIDATE_STYLES.candidateName}>
                                                        {item.performername} {item.lastName}
                                                    </p>
                                                    {item.performeremail && (
                                                        <span style={PARTNER_CANDIDATE_STYLES.infoText}>
                                                            
                                                            {item.performeremail}
                                                        </span>
                                                    )}
                                                    {item.contactNo && (
                                                        <span style={PARTNER_CANDIDATE_STYLES.infoText}>
                                                            
                                                            {getFormatedNumber(item.contactNo)}
                                                        </span>
                                                    )}
                                                    {getFieldData(item.performerData, "projectengagement", "PositionTitle") && (
                                                        <span style={{ ...PARTNER_CANDIDATE_STYLES.infoText, color: "#475569", fontWeight: 500, marginTop: "2px" }}>
                                                            {getFieldData(item.performerData, "projectengagement", "PositionTitle")}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </td>
                                        <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                            <span style={{ ...PARTNER_CANDIDATE_STYLES.infoText, fontWeight: 500, color: "#475569" }}>
                                                {getFieldData(item.performerData, "projectengagement", "AgencyName") || "N/A"}
                                            </span>
                                        </td>
                                        <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                            {item.duration ? (
                                                <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                                                    <span style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        gap: "5px",
                                                        padding: "3px 10px",
                                                        borderRadius: "0px",
                                                        backgroundColor: "#f8fafc",
                                                        border: "1px solid #e2e8f0",
                                                        color: "#0f172a",
                                                        fontSize: "11.5px",
                                                        fontWeight: 600,
                                                        width: "fit-content",
                                                        marginBottom: "4px"
                                                    }}>
                                                        
                                                        {item.duration.duration} Months
                                                    </span>
                                                    <span style={PARTNER_CANDIDATE_STYLES.infoText}>
                                                        Start: <Moment format="MMM Do YYYY">{item.duration.startDate}</Moment>
                                                    </span>
                                                    <span style={PARTNER_CANDIDATE_STYLES.infoText}>
                                                        End: <Moment format="MMM Do YYYY">{item.duration.endDate}</Moment>
                                                    </span>
                                                </div>
                                            ) : (
                                                <span style={{ ...PARTNER_CANDIDATE_STYLES.infoText, color: "#94a3b8" }}>N/A</span>
                                            )}
                                        </td>
                                        <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                            <span style={getStatusBadgeStyle(item.appSubmit)}>
                                                
                                                {item.appSubmit ? "Complete" : "Pending"}
                                            </span>
                                        </td>
                                        <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                            <button
                                                
                                                onClick={() => handlePoShowHide(item)}
                                                style={PARTNER_CANDIDATE_STYLES.actionButton}
                                            >
                                                
                                                <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                                View and eSign
                                                {getPoCount(item)}
                                            </button>
                                        </td>
                                        {usrType !== "recruiter" && (
                                            <td style={PARTNER_CANDIDATE_STYLES.tableCell}>
                                                <button
                                                    onClick={() => handleUploadDoc(item)}
                                                    
                                                    style={PARTNER_CANDIDATE_STYLES.actionButton}
                                                >
                                                    <i className="fa fa-upload" aria-hidden="true"></i>
                                                    Required Documents
                                                </button>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                                {candidateList.length === 0 && (
                                    <tr>
                                        <td colSpan={usrType !== "recruiter" ? 7 : 6} className="p-0">
                                            <div style={PARTNER_CANDIDATE_STYLES.emptyState}>
                                                <div style={PARTNER_CANDIDATE_STYLES.emptyIcon}>
                                                    <i className="fa fa-users" aria-hidden="true"></i>
                                                </div>
                                                <h4 style={PARTNER_CANDIDATE_STYLES.emptyTitle}>No candidates to show yet</h4>
                                                <p style={PARTNER_CANDIDATE_STYLES.emptyText}>
                                                    Candidate records will appear here once onboarding is approved and linked to your partner account.
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <PurchaseOrders
            poShowHide={poShowHide}
            handlePoShowHide={handlePoShowHide}
            candidateObj={candidateObj}
            handleRefreshPartnerCandidates={handleRefreshPartnerCandidates}
        ></PurchaseOrders>
    </React.Fragment>
}
